import React, { useState } from "react";
import usePermisos from "../../../hooks/usePermisos";
import DynamicIcon from "../../../components/DynamicIcon";

const initialForm = {
  Id: 0,
  ClaveRol: "",
  NombreRol: "",
  Rol: 0,
  Proyecto: "",
};

// Tabla de roles
const Tablaroles = ({ roles, onEdit, onPermisos, onDeleteRol }) => {
  if (!roles || roles.length === 0) {
    return (
      <div className="text-center text-gray-400 pt-[12rem] text-[2rem]">
        No hay roles disponibles.
      </div>
    );
  }
  return (
    <table className="w-[98%]">
      <thead className="bg-encabTabla-100 text-white">
        <tr>
          <th className="text-left">Nombre de Rol</th>
          <th>Acción</th>
        </tr>
      </thead>
      <tbody>
        {roles.map((item, index) => (
          <tr
            key={item.Id}
            className={
              index % 2 === 0
                ? "bg-white hover:bg-gray-300"
                : "bg-gray-100 hover:bg-gray-300"
            }
          >
            <td className="text-left pl-4 uppercase">{item.NombreRol}</td>
            <td className="text-center space-x-2">
              <button
                onClick={() => onEdit(item)}
                className="text-green-800 hover:underline"
              >
                <DynamicIcon iconName="edit" size="1em" />
              </button>
              <button
                onClick={() => onPermisos(item.Permisos)}
                className="text-blue-600 hover:underline"
              >
                <DynamicIcon iconName="permisos" size="1em" />
              </button>
              <button
                onClick={() => onDeleteRol(item)}
                className="text-red-600 hover:underline"
              >
                <DynamicIcon iconName="delete" size="1em" />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

// Modal para formulario de rol
const ModalRolForm = ({ isOpen, onClose, formroles ,erroresroles,handleGuardarRol}) => {
const onSave=()=>{
    handleGuardarRol()
        onClose()     
}

  // Agregar rol (placeholder)
    const handleChange = () => {
   
    }

  if (!isOpen) return null;

  return (
     <div className="fixed inset-0 bg-sidebar-200 bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-md shadow-lg min-w-[15rem] w-full max-w-md">
                <div className="bg-sidebar-200 rounded-t-md text-white pl-4 pt-1 font-bold h-[2rem]">
                  {formroles.Id==0 ?"Agregar Rol" : "Editar Rol"}           
                </div>

                <div className="mb-4 px-3">
                    <label className="block mb-1 font-semibold">Nombre de rol:</label>
                    <input
                        type="text"
                        name="NombreRol"
                        value={formroles.NombreRol}
                        onChange={handleChange}
                        required
                        className="w-full border border-gray-300 rounded px-3 py-2"
                    />
                    {/*erroresroles.Id && (
                        <p className="text-red-500 text-sm mt-1">{erroresroles.NombreRol}</p>
                    )*/}
                </div>

                <div className="flex justify-end gap-2 pb-3 pr-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-400 rounded hover:bg-sidebar-200 hover:text-white"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={{onSave}}
                        className="px-4 py-2 bg-sidebar-100 text-white rounded hover:bg-sidebar-200"
                    >
                        Guardar
                    </button>
                </div>
               
            </div>
        </div>
  );
};

// Componente principal
const Permisos = () => {
  const {
    roles,
    errores,
    erroresroles,
    loading,
    deleting,
    showConfirmDelete,
    confirmDeleteRol,
    itemToDelete,
    setShowConfirmDelete,
    handleDeleteRol,
    handleEditarPermisos,
    handleChange,
  } = usePermisos(initialForm);

  const [modalRolOpen, setModalRolOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(initialForm);
  // Abrir modal para agregar
  const handleAddRol = () => {
    setSelectedItem(initialForm);
    setModalRolOpen(true);
  };
  // Abrir modal para edición
  const handleEditRol = (item) => {
    setSelectedItem(item);
    setModalRolOpen(true);
  };

  if (loading)
    return (
      <div className="text-center text-gray-400 pt-[12rem] text-[3.5rem]">
        Cargando roles...
      </div>
    );

  if (deleting)
    return (
      <div className="text-center text-gray-400 pt-[25rem] text-[3.5rem]">
        Eliminando rol, por favor espera...
      </div>
    );

  return (
    <div className="flex flex-col items-center p-4">
        <button onClick={handleAddRol} className="mb-4 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700">
        Agregar Rol
      </button>
      <Tablaroles
        roles={roles}
        onEdit={handleEditRol}
        onPermisos={handleEditarPermisos}
        onDeleteRol={handleDeleteRol}
      />

      <ModalRolForm
        isOpen={modalRolOpen}
        onClose={() => setModalRolOpen(false)}
        erroresroles={erroresroles}
        formroles={selectedItem}
      />

      {showConfirmDelete && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-xl text-center w-[90%] max-w-md">
            <h2 className="text-xl font-semibold mb-4">
              ¿Confirmar eliminación?
            </h2>
            <p className="mb-6">
              ¿Estás seguro de que deseas eliminar el rol{" "}
              <strong>{itemToDelete?.NombreRol}</strong>?
            </p>
            <div className="flex justify-center gap-4">
              <button
                className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
                onClick={confirmDeleteRol}
              >
                Sí, eliminar
              </button>
              <button
                className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400"
                onClick={() => setShowConfirmDelete(false)}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Permisos;
